export const CHART_AGENTS = [{ id: 'vibe', name: 'Vibe / OpenAI', chartName: 'Vibe', color: '#73d8b4' },
  { id: 'technical', name: 'Claude', chartName: 'Claude', color: '#e9c173' }, { id: 'risk', name: 'Gemini', chartName: 'Gemini', color: '#75bcec' }];

export const snapshotSignature = snapshot => snapshot ? JSON.stringify({ symbol: snapshot.symbol, asset: snapshot.asset,
  period: snapshot.period, provider: snapshot.provider, source: snapshot.source_timestamp, stale: snapshot.stale,
  price: snapshot.price, currency: snapshot.currency,
  bars: snapshot.bars?.map(b => [b.time, b.open, b.high, b.low, b.close, b.volume, b.sma20, b.sma50]),
  indicators: Object.entries(snapshot.indicators || {}).sort(([a], [b]) => a.localeCompare(b)), scenarios: snapshot.scenarios }) : '';

export const freshChartEvidence = (snapshot, now = Date.now()) => {
  const time = snapshot?.bars?.at(-1)?.time, age = now / 1000 - time;
  return Boolean(snapshot && !snapshot.stale && Number.isFinite(time) && age >= 0
    && time * 1000 < new Date(now).setUTCHours(0, 0, 0, 0) && age <= (snapshot.asset === 'crypto' ? 2 : 5) * 86400);
};

const EFFECTS = { buy: 'consider_long', sell: 'reduce_or_exit_long', hold: 'no_action' };
const ACTION_NAMES = { buy: 'Buy', sell: 'Sell (long exit)', hold: 'Hold — no Buy/Sell' };

// Display state and chart annotations share one validator. A missing review is never a Hold.
export const chartAgentDisplay = (run, snapshot, visible) => CHART_AGENTS.map(spec => {
  const entry = { ...spec, enabled: Boolean(visible[spec.id]), status: 'not-reviewed', label: 'Not reviewed', marker: null };
  if (!entry.enabled) return { ...entry, status: 'off', label: 'Off' };
  if (!freshChartEvidence(snapshot)) return { ...entry, status: 'stale', label: 'Stale evidence' };
  if (!run) return entry;
  if (!['running', 'completed', 'partial'].includes(run.status)) return { ...entry, status: 'inactive', label: run.status === 'cancelled' ? 'Review stopped' : run.status === 'expired' ? 'Review expired' : 'Review unavailable' };
  if (snapshotSignature(run.snapshot) !== snapshotSignature(snapshot) || run.source_timestamp !== snapshot.source_timestamp)
    return { ...entry, status: 'mismatch', label: 'Different chart' };
  const agent = run.agents?.find(a => a.id === spec.id);
  if (!agent) return entry;
  if (agent.status !== 'completed') return { ...entry, status: agent.status,
    label: agent.status === 'unavailable' ? 'Unavailable' : agent.status === 'running' ? 'Reviewing…' : 'Pending review' };
  const d = agent.decision, candle = snapshot.bars?.at(-1);
  if (!d || !Object.hasOwn(EFFECTS, d.action) || d.symbol !== snapshot.symbol || !run.evidence_id
    || d.evidence_id !== run.evidence_id || d.candle_time !== candle?.time || run.candle_time !== candle.time
    || !agent.completed_at || agent.reference_price !== candle.close || agent.position_effect !== EFFECTS[d.action])
    return { ...entry, status: 'invalid', label: 'Not validated' };
  const marker = { id: `${run.id}-${agent.id}`, agent: agent.id, name: spec.name, time: d.candle_time, action: d.action,
    reference_price: agent.reference_price, reviewed_at: agent.completed_at,
    text: `${spec.chartName} ${d.action[0].toUpperCase()}${d.action.slice(1)}`, reason: d.reason,
    position: d.action === 'buy' ? 'belowBar' : 'aboveBar',
    color: d.action === 'buy' ? '#4ade80' : d.action === 'sell' ? '#fb7185' : '#e9c173',
    shape: d.action === 'buy' ? 'arrowUp' : d.action === 'sell' ? 'arrowDown' : 'circle' };
  return { ...entry, status: d.action, label: ACTION_NAMES[d.action], marker };
});

export const chartAgentMarkers = (run, snapshot, visible) => chartAgentDisplay(run, snapshot, visible)
  .filter(entry => entry.marker).map(entry => entry.marker);